import fetch from "../fetch";

export default ({ id }) =>
  fetch({
    path: `/ct/contacts/${id}`,
    method: "DELETE",
  });
